import React from 'react';
import { Formik, Form, Field } from 'formik';
import clsx from "clsx"
import NetlifyRecaptcha from "./NetlifyRecaptcha"


const encode = (data) => {
  return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
}


export default ({ widget, children, className, validation, classes}) => {
  return (
    <Formik
      validate={validation}
      initialValues={{
        name: '',
        email: '',
        phone: '',
        "required-field": '',
        "g-recaptcha-response": '',
      }}
      onSubmit={(values, { setSubmitting, resetForm, setStatus }) => {
        if (!values["g-recaptcha-response"]) {
          setSubmitting(false)
          setStatus({ message: "captcha-required" })
          return
        }

        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encode({ "form-name": widget.formId, ...values })
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`Form submission failed with status ${response.status}`)
            }

            resetForm();
            setSubmitting(false);
            setStatus({ message: "success" });
          })
          .catch(() => {
            setSubmitting(false)
            setStatus({ message: "error" })
          });
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue, status, errors }) => {
        if (status && status.message && status.message === 'success') {
          if (typeof window !== 'undefined') {
            window.dataLayer.push('event', 'conversion', {'send_to': process.env.GATSBY_GOOGLE_TAGMANAGER_ID + '/jtjDCO3vkJ4BEOO03t0D'})
          }
          return (
            <div className={clsx(classes && classes.success, "html__insert")} dangerouslySetInnerHTML={{__html: widget.successMessage}}/>
          )
        } else {
          return (
            <Form name={widget.formId} method="POST" data-netlify="true"
                  data-netlify-honeypot="required-field" data-netlify-recaptcha="true"
                  className={className}
            style={{marginBottom: 0, width: '100%'}}>
              <div aria-hidden="true" style={{ position: "absolute", left: "-9999px" }}>
                <label>
                  Do not fill this out if you are human:
                  <Field name="required-field" tabIndex="-1" autoComplete="off" />
                </label>
              </div>
              {status && status.message === "error" && (
                <div role="alert" style={{ color: "red", marginBottom: 12 }}>
                  We could not submit the form. Please try again.
                </div>
              )}
              {children({
                isSubmitting,
                submitForm,
                status,
                errors,
                captcha: (
                  <NetlifyRecaptcha
                    setFieldValue={setFieldValue}
                    status={status}
                  />
                ),
              })}
            </Form>
          )
        }
      }}
    </Formik>
  )
}
